import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { site } from "@/content";

const ROUTE = "/privacy";
export const Route = createFileRoute("/privacy")({
  head: () =>
    routeHead(ROUTE, {
      title: "Privacy Policy | NextEra Bookkeeping",
      description: "How NextEra Bookkeeping collects, uses and protects personal information.",
    }),
  component: Page,
});

function Page() {
  return (
    <div className="bg-background text-foreground">
      <section className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="mt-4 font-serif text-4xl text-[color:var(--navy)] sm:text-5xl">
          Privacy Policy
        </h1>
        <div className="prose prose-slate mt-10 max-w-none text-[color:var(--ink)]">
          <p>
            {site.brandName} respects your privacy and is committed to handling personal information
            in accordance with the Australian Privacy Principles under the Privacy Act 1988 (Cth).
          </p>
          <h2 className="font-serif text-xl text-[color:var(--navy)]">Information we collect</h2>
          <p>
            We collect information you provide directly, including your name, business, contact
            details and information shared during a Strategic Finance Review.
          </p>
          <h2 className="font-serif text-xl text-[color:var(--navy)]">How we use information</h2>
          <p>
            Information is used to respond to enquiries, deliver bookkeeping and finance services
            and communicate about your engagement with us.
          </p>
          <h2 className="font-serif text-xl text-[color:var(--navy)]">Contact</h2>
          <p>
            To request access to, or correction of, your personal information, contact us using the
            details on the Contact page.
          </p>
          <p className="mt-10 text-xs text-[color:var(--subtle)]">{site.legalWording}</p>
        </div>
      </section>
    </div>
  );
}
